import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'

import HelperText from './HelperText'

import UnitSelect from 'components/resource/UnitSelect'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    //marginTop: theme.spacing(2),
  },
}))

const UnitSelectField = ({
  field: {
    name,
    value,
    onChange,
  },
  form: {
    setFieldValue,
  },
  error,
  touched,
  item,
}) => {

  const classes = useStyles()
  const title = item.title || name

  const {
    unitType,
    customUnits,
  } = item

  return (
    <FormControl component="fieldset" className={ classes.root }>
      <InputLabel htmlFor={ name }>{ title }</InputLabel>
      <UnitSelect
        type={ unitType }
        value={ value || '' }
        onChange={ (value) => setFieldValue(name, value) }
        customUnits={ customUnits }
        error={ error ? true : false }
        touched={ touched }
      />
      <HelperText
        helperText={ item.helperText }
        error={ error ? true : false }
        touched={ touched }
      />
    </FormControl>
  )
}

export default UnitSelectField